import Menu from './src/menu'

export default Menu



// WEBPACK FOOTER //
// ./src/components/tofu-menu/index.js